import { useQuery } from '@tanstack/react-query';
import { fetchData } from 'utils';
import useSmartlook from 'hooks/useSmartlook';

export type ClientEmailData = {
  email: string;
};

export async function getClientEmail() {
  return fetchData('/client/email');
}

export default function useClientEmailQuery(
  isEnabled = false,
  refetchInterval: number | false = false,
) {
  const { error } = useSmartlook();
  return useQuery<ClientEmailData>({
    queryKey: ['client', 'email'],
    queryFn: async () => {
      try {
        const data = await getClientEmail();
        return data;
      } catch (e) {
        error('[useClientQuery][GET /client/email]', e);
        throw e;
      }
    },
    enabled: isEnabled,
    refetchInterval,
    staleTime: Infinity,
  });
}
